import {makeErrorMessage} from '../../util/error';

/**
 * @ngInject
 */
export default class ErrorInterceptor {
  /**
   * Constructor of the class.
   *
   * @param {$q}         $q
   * @param {$injector}  $injector
   * @param {$rootScope} $rootScope
   * @param {$log}       $log
   * @param {$location}  $location
   * @param {$state}     $state
   * @param {$localStorage} $localStorage
   */
  constructor($q, $injector, $rootScope, $log, $location, $state, $localStorage, $window) {
    this.$q = $q;
    this.$injector = $injector;
    this.$rootScope = $rootScope;
    this.$log = $log;
    this.$location = $location;
    this.$state = $state;
    this.$localStorage = $localStorage;
    this.$window = $window;

    this.responseError = response => {
      const errorMessage = makeErrorMessage(response);
      return this.handleError(errorMessage);
    };
  }

  handleError(error) {
    const {Status, StatusText, Code} = error;
    switch (Status) {
      case -1:
        return this.$q.reject({
          ...error,
          MessagePL: 'Błąd połączenia z serwerem',
          Errors: ['Sprawdź swoje połącznie z internetem']
        });
      case 400:
        return this.$q.reject(error);
      case 403:
        if (Code === 'OPERATION_IS_BLOCKED_BY_DATA_MODIFICATION_LOCK') {
          return this.$q.reject({
            ...error,
            MessagePL: 'Blokada modyfikacji danych',
            Errors: ['Blokada modyfikacji danych jest włączona. Skontaktuj się z administratorem szkoły']
          });
        }

        this.redirect(StatusText);
        return this.$q.reject(error);
      default:
        return this.$q.reject(error);
    }
  }

  redirect(statusText) {
    this.$localStorage.$reset();
    if (statusText === 'ModuleInaccessible') {
      if (process.env.NODE_ENV !== 'development') {
        this.$window.location.href = this.$location.protocol() + '://' + this.$location.host() + '/loguj/przenies/swietlica/schoolCommonRoom/select';
      }
    } else {
      this.$rootScope.$broadcast('SCR.change');
      this.$state.go('schoolCommonRoom.select', {}, {reload: 'schoolCommonRoom.select'});
    }
  }
}
